module.exports = __webpack_public_path__ + "static/media/90.12fa7015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/90.jpg
// module id = 1023
// module chunks = 0